import { Icon, IconDocument, IconInfo } from '@flixbus/honeycomb-icons-react';
import { getLinkedOrders } from '../../apis';
import { useVoucher } from '../../context/VoucherProdiver';
import InfoDisplay from '../VoucherInfo/InfoDisplay';
import styles from './voucher-order-info.module.scss';
import { useEffect, useState } from 'react';
import React from 'react';
import { Link, Spinner } from '@flixbus/honeycomb-react';
import { VoucherLinkedOrder } from '../../types/VoucherLinkedOrder';

const VoucherOrderInfo = () => {
  const { data } = useVoucher();
  const [orders, setOrders] = useState<VoucherLinkedOrder[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const backendUrl = process.env.REACT_APP_BIRDVIEW_URL || 'https://birdview-dev.flix.tech';

  const originalOrder = orders?.find(order => order.voucherTypeUse === 'refund');
  const ordersWithVoucher = orders?.filter(order => order.voucherTypeUse === 'used');

  useEffect(() => {
    setLoading(true);
    getLinkedOrders(data.id).then(res => {
      setOrders(res);
      setLoading(false);
    });
  }, [data.id]);

  const mapOrderLinks = (orders: VoucherLinkedOrder[]) => {
    return (
      <>
        {orders.map((order: VoucherLinkedOrder, index) => (
          <React.Fragment key={index}>
            <Link href={backendUrl + `/orders/${order.orderNumber}`} target={'_blank'} key={index}>
              {order.orderNumber}
            </Link>
            {index < orders.length - 1 && ' | '}
          </React.Fragment>
        ))}
      </>
    );
  };

  return (
    <>
      <div className={styles.container}>
        <InfoDisplay
          title={
            <>
              <Icon appearance={'secondary'} size={4} InlineIcon={IconDocument} />
              {' Order info'}
            </>
          }
          fields={
            loading
              ? [
                  {
                    value: <Spinner extraClasses={styles.spinner} size={'xl'} />,
                  },
                ]
              : orders.length > 0
                ? [
                    {
                      label: 'Original order',
                      value: originalOrder ? (
                        <Link
                          href={backendUrl + `/orders/${originalOrder.orderNumber}`}
                          target={'_blank'}
                        >
                          {originalOrder.orderNumber}
                        </Link>
                      ) : (
                        ' not found'
                      ),
                    },
                    {
                      label: 'Order(s) with the voucher',
                      value: (ordersWithVoucher && mapOrderLinks(ordersWithVoucher)) || 'not found',
                    },
                  ]
                : [
                    {
                      value: 'No orders linked to this voucher',
                    },
                  ]
          }
          message={{
            icon: <Icon InlineIcon={IconInfo} extraClasses={styles.warningColor}></Icon>,
            value:
              'If you need to access order information updated before 05/05/2024, please use the old Backend tool.',
          }}
        />
      </div>
    </>
  );
};

export default VoucherOrderInfo;
